<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [icon]="panelIcon">

    <div class="calendar-button-container" *ngIf="dataSource">
      <button *ngIf="!isNew" class="btn btn-fill btn-primary float-right calendar-button" type="button"
        (click)="onOpenCalendar()">
        <fa-icon icon="calendar-alt" size="1x" class='mr-2 calendar-icon'></fa-icon>
        Calendario

      </button>
    </div>
    <dx-data-grid id="gridContainer" [dataSource]="dataSource" (onToolbarPreparing)="onToolbarPreparing($event)"
      (onEditorPreparing)="onEditorPreparing($event)" (onSelectionChanged)="updateSelectedRows($event)"
      [scrolling]="{ mode: 'standard', showScrollbar: 'always' }" (onCellPrepared)="onCellPrepared($event)"
      (onExporting)="onExporting($event)">

      <!-- Definición de las columnas -->
      <dxo-selection mode="multiple" showCheckBoxesMode="always" caption="Seleccionar"></dxo-selection>

      <!-- Filtrado por defecto -->
      <dxi-column dataField="stateHr.requestState1" [visible]="false" sortOrder="asc"> </dxi-column>
      <dxi-column dataField="state.requestState1" [visible]="false" sortOrder="desc"> </dxi-column>

      <dxi-column dataField="state.name" caption="Estado" alignment="center" width="110">
      </dxi-column>
      <dxi-column dataField="stateHr.name" caption="RRHH" alignment="center" width="110">
      </dxi-column>
      <dxi-column *ngIf="displayHolidayBag" dataField="associatedHolidayBag.state.name" caption="Bolsa"
        alignment="center" width="110">
      </dxi-column>

      <dxi-column dataField="company.name" caption="Empresa"></dxi-column>
      <dxi-column dataField="user.fullName" caption="Nombre"></dxi-column>

      <dxi-column dataField="type" caption="Tipo" alignment="center" width="200"></dxi-column>

      <!-- <dxi-column dataField="startDate" caption="Duración" alignment="center"
        [calculateDisplayValue]="getDuration"></dxi-column> -->
      <!-- NO SE MUESTRA PARA QUE SALGAN LOS CAMPOS DE ENDDATE Y EL BOTON DE EDITAR -->

      <dxi-column dataField="startDate" caption="Inicio" alignment="center" [allowFiltering]="false" dataType="date"
        format="dd/MM/yyyy"></dxi-column>
      <dxi-column dataField="endDate" caption="Fin" alignment="center" [allowFiltering]="false" dataType="date"
        format="dd/MM/yyyy"></dxi-column>
      <dxi-column dataField="createdAt" caption="Fecha Solicitud" alignment="center" [allowFiltering]="false"
        dataType="date" format="dd/MM/yyyy"></dxi-column>

      <!-- Templates -->
      <ng-container *ngIf="isCrud">
        <dxi-column *ngIf="!exporting" dataField="request1" caption="Acciones" [allowFiltering]="false"
          [allowSorting]="false" alignment="center" cellTemplate="buttonCRUDTemplate"
          [allowExporting]="false"></dxi-column>
        <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
          <button rel="tooltip" type="button" class="btn btn-success btn-action" (click)="canEditRequest(data.key) && selectRowToEdit(data.key)" [disabled]="!canEditRequest(data.key)">
            <i class="material-icons">edit</i>
          </button>
        </ng-container>
      </ng-container>

      <!-- Añadir nuevos -->
      <!-- d-none No se ve, habría que editar listFormEditBase.ts -->
      <div *dxTemplate="let data of 'addNew'">

        <!-- Botón Gestionar -->
        <button id="manage-button" *ngIf="selectedRows.length > 0" class="btn btn-success btn-sm btn-accept" (click)="!disableManageButton && onClickManage()" [disabled]="disableManageButton">
          <i class="material-icons icon-centered">check</i>
          <span class="d-none d-sm-inline-block ">Gestionar</span>
        </button>
      </div>
      <dxo-export [enabled]="true" [fileName]="'Listado_Solicitudes_LivesHR'"></dxo-export>
    </dx-data-grid>


    <!-- Panel calendario -->
    <!--  </app-generic-panel>
    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [icon]="panelIcon">
  
  
  
    </app-generic-panel> -->

  </app-generic-panel>
  <br>
</app-generic-container>